<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="'background-alternative'"
    [themeFlush]="true"
    class="personal-details__section"
  >
    <dgx-components-grid-container>
      <dgx-components-card
        [spacing]="5"
        class="personal-details__card-container"
      >
        <checkout-progression-steps />

        <dgx-components-grid-row>
          <dgx-components-grid-column [xs]="12">
            <h1 class="personal-details__title">
              {{ vm.cmsData.pageTitle }}
            </h1>
          </dgx-components-grid-column>
        </dgx-components-grid-row>

        <dgx-components-grid-row>
          <dgx-components-grid-column [md]="6" [xs]="12">
            <checkout-personal-details-form
              (submitted)="cs.onFormSubmit($event)"
              class="personal-details-form"
            />
          </dgx-components-grid-column>

          <dgx-components-grid-column [md]="6" [xs]="12">
            <div class="personal-details__aside">
              <dgx-basket-summary [canRemoveSelectedQuotes]="false" />
            </div>
          </dgx-components-grid-column>
        </dgx-components-grid-row>
      </dgx-components-card>

      <dgx-components-button-navigate-back />
    </dgx-components-grid-container>
  </dgx-components-grid-section>

  <div [content]="main" editable-area></div>
</ng-container>
